<template>
  <div>
    <v-simple-table dense class="zebra">
      <thead>
        <tr>
          <th v-for="(el, i) in mainModel" :key="i" class="text-left px-2" :style="el.width ? { minWidth: el.width + 'px' } : null">
            {{ el.title }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr is="Row" v-for="(row, r) in rows" :key="r.id" :row="row" :model="mainModel" :group="group" @click1="onClick(row)" @toggle="onClick" />
      </tbody>
    </v-simple-table>
  </div>
</template>
<script>
export default {
  components: {
    Row: () => import("./tableRow"),
  },
  props: {
    group: Array,
    data: [Array],
    model: { type: Array, default: () => [] },
  },
  data() {
    return {
      rows: [],
    };
  },
  created() {
    this.rows = this.getData(this.data, this.group);
  },
  computed: {
    mainModel() {
      let res = this.model;
      if (this.group && this.group.length) res = [{ name: "group", width: 50 }, ...res];
      return res;
    },
  },

  methods: {
    onClick(e) {
      if (!e.group) return;
      const index = this.rows.indexOf(e);
      if (index === -1) return;

      // переключаем состояние
      e.open = !e.open;

      if (e.open) {
        // ➕ ВСТАВИТЬ child
        const children = e.child.map(ch => ({
          ...ch,
          __parent: e.id, // маркер родителя
        }));

        this.rows.splice(index + 1, 0, ...children);
      } else {
        // ➖ УБРАТЬ child
        this.rows = this.rows.filter(row => row.__parent !== e.id);
      }
    },
    getData(data, group) {
      let res;
      if (group && group.length) {
        const g = group[0];
        res = Object.values(
          data.reduce((acc, item) => {
            const f = item[g];
            if (!acc[f]) {
              acc[f] = { [g]: f, value: 0, child: [], open: false, group: g, id: `${g}-${f}` };
            }
            acc[f].child.push(item);
            acc[f].value += Number(item.value) || 0;

            return acc;
          }, {}),
        ).sort((a, b) => {
          if (a[g] == null) return -1;
          if (b[g] == null) return 1;
          return String(a[g]).localeCompare(String(b[g]));
        });
      } else res = data;
      return res;
    },
  },
};
</script>
<style scoped>
.zebra tbody tr:nth-child(even) {
  background-color: #d8d8d8;
}
</style>
